document.addEventListener('DOMContentLoaded', () => {
  const config = {
    hoverDelay: 150, // ms before closing
    mobileBreakpoint: 990 // px - adjust to your theme
  };
  
  // Check if mobile
  const isMobile = () => window.innerWidth < config.mobileBreakpoint;
  
  document.querySelectorAll('details.mega-menu').forEach((details) => {
    const summary = details.querySelector('summary');
    
    // Skip drawer menus
    if (details.closest('header-drawer, menu-drawer')) return;
    
    let closeTimeout;
    
    // Accessibility attributes
    summary.setAttribute('aria-expanded', details.hasAttribute('open'));
    if (summary.nextElementSibling?.id) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    
    // Desktop hover behavior
    if (!isMobile()) {
      details.addEventListener('mouseenter', () => {
        if (closeTimeout) clearTimeout(closeTimeout);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });
      
      details.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, config.hoverDelay);
      });
    }
    
    // Click behavior (works on both mobile and desktop)
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = details.hasAttribute('open');
      
      // Close all other dropdowns
      document.querySelectorAll('[id^="Details-"][open]').forEach((otherDetails) => {
        if (otherDetails !== details) {
          otherDetails.removeAttribute('open');
          otherDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Toggle current dropdown
      if (isOpen) {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      } else {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });
    
    // Escape key to close
    details.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      }
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[id^="Details-"]')) {
      document.querySelectorAll('[id^="Details-"][open]').forEach((details) => {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
    }
  });
});